import React from "react";
import { useI18n } from "../lib/i18n";

const STATUS_STYLES = {
  awaiting_payment: "bg-amber-100 text-amber-800 border-amber-200",
  new: "bg-slate-100 text-slate-700 border-slate-200",
  searching_partner: "bg-blue-100 text-blue-800 border-blue-200",
  partner_assigned: "bg-indigo-100 text-indigo-800 border-indigo-200",
  appointment_pending: "bg-purple-100 text-purple-800 border-purple-200",
  appointment_confirmed: "bg-cyan-100 text-cyan-800 border-cyan-200",
  in_progress: "bg-orange-100 text-orange-800 border-orange-200",
  completed: "bg-green-100 text-green-800 border-green-200",
  cancelled: "bg-red-100 text-red-700 border-red-200",
  disputed: "bg-red-100 text-red-700 border-red-200",
  paid: "bg-green-100 text-green-800 border-green-200",
  pending: "bg-amber-100 text-amber-800 border-amber-200",
  failed: "bg-red-100 text-red-700 border-red-200",
  refunded: "bg-slate-100 text-slate-700 border-slate-200",
};

export function StatusBadge({ status, label, testId }) {
  const { t } = useI18n();
  const style = STATUS_STYLES[status] || "bg-slate-100 text-slate-700 border-slate-200";
  const text = label || t(`status.${status}`) || status;
  return (
    <span
      data-testid={testId || `status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold border ${style} whitespace-nowrap`}
    >
      {text}
    </span>
  );
}
